export default __webpack_public_path__ + "static/media/add_photo_profile.bd978537.png";